// src/graphql/mutations/setPersId.js
import { gql } from '@apollo/client';

export const SET_PERS_ID = gql`
  mutation setPersId($system_id: String!, $pers_id: String!) {
    setPersId(system_id: $system_id, pers_id: $pers_id) {
      result
    }
  }
`;

